import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const getGreetingData = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return { text: 'Chào buổi sáng', icon: '☕' };
  if (hour >= 12 && hour < 18) return { text: 'Chào buổi chiều', icon: '☀️' };
  if (hour >= 18 && hour < 22) return { text: 'Chào buổi tối', icon: '🌙' };
  return { text: 'Chào buổi khuya', icon: '🦉' };
};

function DashboardHeader({ title, userName, actions = null, sx = {} }) {
  const [greeting, setGreeting] = useState(getGreetingData);

  useEffect(() => {
    if (title) return;
    const intervalId = setInterval(() => {
      const newData = getGreetingData();
      setGreeting(prev => (prev.text === newData.text) ? prev : newData);
    }, 60000);
    return () => clearInterval(intervalId);
  }, [title]);

  const isLoggedIn = userName && userName.trim() !== '' && userName !== 'Khách';
  const displayName = isLoggedIn ? userName : 'bạn';

  return (
    <Box 
      sx={{ 
        px: 3, pt: 2.5, pb: 2.5,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        bgcolor: '#ffffff', gap: 2, ...sx
      }}
    >
      <Box sx={{ minWidth: 0, flex: '1 1 auto' }}>
        {title ? (
          <Typography variant="h5" fontWeight="700" color="text.primary" sx={{ letterSpacing: '-0.5px' }}>
            {title}
          </Typography>
        ) : (
          <Typography variant="h5" fontWeight="600" color="text.primary" sx={{ letterSpacing: '-0.5px' }}>
            {greeting.text},{' '}
            <Box component="span" fontWeight="800" color="primary.main">
              {displayName}
            </Box>! {greeting.icon}
          </Typography>
        )}
      </Box>
      {/* Vùng bên phải cùng hàng tiêu đề (vd nút chọn công ty) — không chiếm dòng riêng. Bám DÒNG ĐẦU của
          tiêu đề (flex-start) để luôn ngang nút cài đặt, kể cả khi tiêu đề xuống 2 dòng trên điện thoại. */}
      {actions && <Box sx={{ flexShrink: 1, minWidth: 0, display: 'flex', justifyContent: 'flex-end', alignSelf: 'flex-start', minHeight: 32, alignItems: 'center' }}>{actions}</Box>}
    </Box>
  );
}

export default React.memo(DashboardHeader);